import { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { UltimasLiquidacionesContext } from 'core/reporte/contexts/UltimasLiquidacionesContext';
import { UltimasLiquidacionesForm } from '../../components/UltimasLiquidacionesForm/UltimasLiquidacionesForm';
import { UltimasLiquidacionesList } from '../../components/UltimasLiquidacionesList/UltimasLiquidacionesList';

export const UltimasLiquidacionesPage = () => {
  const { showResults } = useContext(UltimasLiquidacionesContext);

  return (
    <>
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Title>Filtros</Card.Title>
            <Card.Body $padding>
              <UltimasLiquidacionesForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {showResults && (
        <Row>
          <Col>
            <Card>
              <Card.Title>Ultimas liquidaciones</Card.Title>
              <Card.Body $padding>
                <UltimasLiquidacionesList />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};
